export class MissingEnvironmentVariableError extends Error {
  constructor(variableName: string) {
    super(
      `The env var "${variableName}" must be set either in the .env file or in the environment. See the README under the heading "Environment Variables" for more details.`,
    );
    this.name = 'MissingEnvironmentVariableError';
  }
}
